"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeySchema = exports.DigirodeoCredentialSchema = exports.OptiWeightCredentialSchema = exports.CeresTagCredentialSchema = exports.AngusClientCrendetialSchema = exports.OptiweighClientCrendetialSchema = exports.CeresTagClientCrendetialSchema = exports.ClientCrendetialSchema = exports.ApiKeySchema = exports.GcpKeySchema = exports.KeyScopeSchema = void 0;
const zod_1 = require("zod");
const credential = __importStar(require("../misc/credential"));
exports.KeyScopeSchema = zod_1.z.enum(["aglive", "angus", "cerestag", "optiweigh", "digirodeo"]);
//gcp key
exports.GcpKeySchema = zod_1.z.object({
    type: zod_1.z.literal("gcpKey"),
    clientId: zod_1.z.string(),
    key: zod_1.z.string(),
    keyId: zod_1.z.string(),
    gcpProductId: zod_1.z.string(),
    lastUsed: zod_1.z.date(),
    expiration: zod_1.z.date(),
});
//API Key
exports.ApiKeySchema = zod_1.z.object({
    type: zod_1.z.literal("apiKey"),
    scope: exports.KeyScopeSchema,
    keyId: zod_1.z.string(),
    key: zod_1.z.string(),
    clientId: zod_1.z.string(),
    lastUsed: zod_1.z.date(),
    credential: zod_1.z.object({
        clientId: zod_1.z.string(),
        clientSecret: zod_1.z.string(),
        apiKey: zod_1.z.string(),
        agliveAPIKey: zod_1.z.string()
    }),
    gcp_product_id: zod_1.z.string().optional(),
    revokedDate: zod_1.z.date().optional(),
    expiration: zod_1.z.date().optional(),
    createdAt: zod_1.z.date()
});
//Client Credential
exports.ClientCrendetialSchema = zod_1.z.object({
    type: zod_1.z.literal("clientCredential")
});
exports.CeresTagClientCrendetialSchema = zod_1.z.object({
    scope: zod_1.z.literal(exports.KeyScopeSchema.enum.cerestag),
    credential: credential.CeresTagCredentialSchema
}).merge(exports.ClientCrendetialSchema);
exports.OptiweighClientCrendetialSchema = zod_1.z.object({
    scope: zod_1.z.literal(exports.KeyScopeSchema.enum.optiweigh),
    credential: credential.OptiWeighCredentialSchema
}).merge(exports.ClientCrendetialSchema);
exports.AngusClientCrendetialSchema = zod_1.z.object({
    scope: zod_1.z.literal(exports.KeyScopeSchema.enum.angus),
    credential: credential.AngusCredentialSchema
}).merge(exports.ClientCrendetialSchema);
//Plugin Credential
exports.CeresTagCredentialSchema = zod_1.z.object({
    type: zod_1.z.literal("Ceres Tag"),
    keyId: zod_1.z.string(),
    credential: zod_1.z.object({
        clientId: zod_1.z.string(),
        apiKey: zod_1.z.string().optional(),
        agliveAPIKey: zod_1.z.string().optional(),
        clientSecret: zod_1.z.string(),
    }),
    createdAt: zod_1.z.date()
});
exports.OptiWeightCredentialSchema = zod_1.z.object({
    type: zod_1.z.literal("optiWeigh"),
    keyId: zod_1.z.string(),
    credential: zod_1.z.object({
        clientId: zod_1.z.string(),
        clientSecret: zod_1.z.string(),
        apiKey: zod_1.z.string(),
        agliveAPIKey: zod_1.z.string()
    }),
    createdAt: zod_1.z.date()
});
exports.DigirodeoCredentialSchema = zod_1.z.object({
    type: zod_1.z.literal("DigiRodeo"),
    keyId: zod_1.z.string(),
    key: zod_1.z.string(),
    credential: zod_1.z.object({
        username: zod_1.z.string(),
        password: zod_1.z.string(),
    }),
    createdAt: zod_1.z.date()
});
exports.KeySchema = zod_1.z.union([
    exports.GcpKeySchema,
    exports.ApiKeySchema,
    exports.CeresTagClientCrendetialSchema,
    exports.OptiweighClientCrendetialSchema,
    exports.AngusClientCrendetialSchema,
    exports.CeresTagCredentialSchema,
    exports.OptiWeightCredentialSchema,
    exports.DigirodeoCredentialSchema
]);
